// src/utils/whatsappOrderReviewMessages.js

export const buildReviewRequestWhatsAppMessage = (order) => {
  const firstName = order.customer?.name?.split(" ")[0] || "Customer";

  const site =
    process.env.REACT_APP_API_URL
      ? process.env.REACT_APP_API_URL.replace(/\/api$/, "")
      : "";

  const reviewLink = site
    ? `${site}/account/orders/${order.orderNumber}`
    : "";

  const message = `
*LIONS STORE*

Hello ${firstName},

We hope you are satisfied with your order *#${order.orderNumber}*.

Your feedback is very important to us and helps other customers make the right choice.

You can leave your review here:
${reviewLink}

----------------------

مرحباً ${firstName}،

نأمل أن تكون راضياً عن طلبك رقم *${order.orderNumber}*.

رأيك يهمنا ويساعد عملاء آخرين على اتخاذ القرار الصحيح.

يمكنك ترك تقييمك من هنا:
${reviewLink}

شكراً لثقتك بنا،
*LIONS*
  `.trim();

  return encodeURIComponent(message);
};
